module.exports = __webpack_public_path__ + "img/t_robot.b8f27a55.png";